import { KILL_SWITCH } from './kill-switch';

export const environment = {
  production: true,
  urlService: 'https://redi-app.com/api-promoter',
  killSwitch: KILL_SWITCH,
};
